/**
 * slider component
 */

import { Component, Input, Output, EventEmitter, OnInit, ViewChild, AfterViewInit } from '@angular/core';

import { ISliderFieldSpecs } from 'libraries/module/formbuilder/fields/interfaces/field-specs';
import { Slider } from "primeng/slider";

@Component({
    selector: 'slider-field',
    template: `
        <form-field [formGroup]="fieldConfig.formGroup"
                    [options]="fieldConfig"
                    [attr.class]="fieldConfig.className">
            <p-slider #slider
                      [formControlName]="fieldConfig.formControlName"
                      [min]="fieldConfig.min"
                      [max]="fieldConfig.max"
                      [range]="fieldConfig.range"
                      (onChange)="onChangeEvent($event)">
            </p-slider>
        </form-field>
    `,
    styleUrls: ['./slider-field.scss']
})
export class SliderFieldComponent implements AfterViewInit{

    @ViewChild('slider')
    public readonly slider: Slider;

    @Input()
    public fieldConfig: ISliderFieldSpecs;

    @Output()
    public readonly onChange: EventEmitter<number | [number, number]> = new EventEmitter();

    public ngAfterViewInit(): void {
        const values: number[] = this.fieldConfig.formGroup.get(this.fieldConfig.formControlName).value;
        if(values[0] === 0 && values[1] === 0){
            this.slider.handleIndex = 1;
        }
    }

    public onChangeEvent(event: number | [number, number]): void {
        // @ts-ignore
        if(event.values[0] === 0 && event.values[1] === 0){
            this.slider.handleIndex = 1;
        }
        this.onChange.emit(event);
    }
}
